//
// Super Toggle
// --------------------------------------------------
// Function that lets you provide a list of classes to toggle at the same time
// e.g. superToggle(myElement, ['opacity-0', '-translate-y-full']);

export function superToggle(element, classes) {
    for (let CLASS of classes) {
        element.classList.toggle(CLASS);
    }
}